class SquamaItem extends HTMLElement {
    connectedCallback() {
        this.reinit();
        this.addEventListener("focusin", this.handleFocusIn);
        this.addEventListener("focusout", this.handleFocusOut);
        this.resizeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.windowResizeX,
            this.reinit.bind(this)
        );
    }

    disconnectedCallback() {
        this.removeEventListener("focusin", this.handleFocusIn);
        this.removeEventListener("focusout", this.handleFocusOut);
        this.resizeUnsubscriber?.();
    }

    handleFocusIn() {
        this.setAttribute("data-focused", "");
    }

    handleFocusOut(event) {
        // remove data-focused when focus is out of squama-item
        if (!this.contains(event.relatedTarget)) {
            this.removeAttribute("data-focused");
            this.scrollTop = 0;
        }
    }

    reinit() {
        if (window.visualViewport.width < 767) {
            this.removeAttribute("data-status");
            this.style.removeProperty("height");
            return;
        }

        setTimeout(() => {
            // Set height for squama item on screens greater 767px.
            // Other wise heigh is 'auto' using css rule
            this.style.height = this.clientHeight + "px";
            this.setAttribute("data-status", "ready");
        }, 100);
    }
}

customElements.define("squama-item", SquamaItem);
